
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function ContactTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Contact History</CardTitle>
        <CardDescription>Previous inquiries and responses</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">You haven't submitted any inquiries yet.</p>
        <Button asChild variant="outline" className="w-full mt-4">
          <a href="/contact">Contact Us</a>
        </Button>
      </CardContent>
    </Card>
  );
}
